<template>
  <div class="video-room-chat-message" :class="{'odd':odd}">
    <div class="video-room-chat-message__date">
      {{ date }}
    </div>
    <div v-linkified class="video-room-chat-message__wrap" v-html="message.message" />
  </div>
</template>

<script>

import * as moment from 'moment';
import { computed, toRefs } from '@vue/composition-api';

export default {
  name: 'VideoRoomChatMessage',
  props: {
    message: {
      type: Object,
      required: true,
    },
    odd: Boolean,
  },
  setup(props) {
    const { message } = toRefs(props);

    return {
      date: computed(() => moment(message.value.date).format('HH:mm:ss')),
    };
  },
};
</script>

<style lang="scss" scoped>
.video-room-chat-message {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 0.25rem;

  &.odd {
    align-items: flex-end;

    .video-room-chat-message__wrap {
      background: linear-gradient(135deg, #0A82D9 0%, #0099E0 100%);
      color: #FFFFFF;
      border-bottom-right-radius: 4px;
    }

    .video-room-chat-message__date {
      text-align: right;
    }
  }

  &__wrap {
    max-width: 14rem;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    border-bottom-left-radius: 4px;
    padding: 0.4rem 0.75rem;
    overflow-wrap: break-word;
    font-size: 0.8125rem;
    line-height: 1.45;
    color: rgba(255, 255, 255, 0.9);
  }

  &__date {
    font-size: 0.625rem;
    color: rgba(255, 255, 255, 0.3);
    margin-top: 0.125rem;
    padding: 0 0.25rem;
  }
}
</style>
